import { Injectable } from '@angular/core';

import Swal, { SweetAlertResult } from 'sweetalert2';

enum TipoMensagem {
  ERRO = 'error',
  SUCESSO = 'success',
  ALERTA = 'warning',
  INFO = 'info'
}

interface IMensagem {
  titulo: string;
  mensagem: string;
  tipo?: TipoMensagem | any;
}

@Injectable(
  {providedIn: 'root'}
)
export class MensagemService {

  constructor() { }

  avisoMensagem(alerta: IMensagem) {
    setTimeout(() => Swal.fire(alerta.titulo, alerta.mensagem, alerta.tipo), 100);
  }

  avisoMensagemSucesso(mensagem: string = 'Operação realizada com sucesso', titulo?: string) {
    if (!titulo) titulo = 'Sucesso!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.SUCESSO });
  }

  avisoMensagemError(mensagem: string = 'Ocorreu um erro na operação', titulo?: string) {
    if (!titulo) titulo = 'Erro!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.ERRO });
  }

  avisoMensagemAlerta(mensagem: string = 'Não foi possivel realizar operação', titulo?: string) {
    if (!titulo) titulo = 'Alerta!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.ALERTA });
  }

  avisoMensagemInfo(mensagem: string = 'Operação com detalhe importante', titulo?: string) {
    if (!titulo) titulo = 'Fique atento!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.INFO });
  }

  avisoMensagemSalvo(mensagem: string = 'Registro adicionado com sucesso', titulo?: string) {
    if (!titulo) titulo = 'Sucesso!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.SUCESSO });
  }

  avisoMensagemAtualizado(mensagem: string = 'Registro alterado com sucesso', titulo?: string) {
    if (!titulo) titulo = 'Sucesso!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.SUCESSO });
  }

  avisoMensagemApagado(mensagem: string = 'Registro excluído com sucesso', titulo?: string) {
    if (!titulo) titulo = 'Sucesso!';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.SUCESSO });
  }

  avisoMensagemCPFInválido(mensagem: string = '', titulo?: string) {
    if (!titulo) titulo = 'CPF Inválido';
    this.avisoMensagem({ titulo, mensagem, tipo: TipoMensagem.ALERTA });
  }

  avisoFormularioInvalido() {
    this.avisoMensagem({ titulo: 'Preencha todos os campos obrigatórios', mensagem: '', tipo: TipoMensagem.ALERTA });
  }

  avisoMensagemCondicional(mensagem: string, titulo?: string, tipo?: any): Promise<SweetAlertResult<any>> {
    return Swal.fire({
      title: titulo,
      text: mensagem,
      icon: tipo,
      showCancelButton: true,
      cancelButtonText: 'Não, fechar',
      confirmButtonText: 'Sim, confirmar',
    })
  }

  avisoMensagemAguarde() {
    Swal.fire({
      title: 'Aguarde...',
      text: '',
      icon: 'info',
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  fecharMensagem(): void {
    Swal.close()
  }

}
